// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__171yb","navText":"Navbar_navText__1XvC2","navLogo":"Navbar_navLogo__3O3nO","imgLogo":"Navbar_imgLogo__1QnMu"};